const PlayerSpeed = {
    'Slow': 3,
    'Normal': 2,
    'Fast': 1
}

export default PlayerSpeed;

export function getPlayerSpeedFromKey(key) {
    return Object.keys(PlayerSpeed).find(k => PlayerSpeed[k] === key);
}